import {
  Card,
  CardContent,
  Box,
  Container,
  useMediaQuery,
} from "@mui/material";
import CustomToolbar from "../component/AppBar/CustomToolbar";
import NavigationCard from "../component/AppBar/NavigationCard";
import { useContext, useEffect, useState } from "react";
import { RolesContext } from "../context/User";
import { useLocation } from "react-router-dom";
import NavBarMobil from "../component/MobilComp/navbarMobil";
import Footer from "../component/AppBar/Footer";
import HospitalNavCard from "../component/Hospital/HospitalNavCard";

const MainCustomCard = ({ children }) => {
  const [stateroles, dispatchroles] = useContext(RolesContext);
  const [displayMenu, setDisplayMenu] = useState("none");
  const [portal, setPortal] = useState(true);
  const location = useLocation();
  const isXs = useMediaQuery("(max-width:600px)");
  const isMd = useMediaQuery("(min-width:601px) and (max-width:1300px)");
  const isXl = useMediaQuery("(min-width:1301px)");

  const isHospitalUser = stateroles.roles?.includes("hospital");
  const isChemoPage = location.pathname === "/chemo";

  useEffect(() => {
    if (location.pathname == "/portal") {
      setDisplayMenu("none");
      setPortal(true);
    } else if (
      location.pathname.includes("/device") ||
      location.pathname === "/successful"
    ) {
      setPortal(false);
    } else {
      setDisplayMenu("block");
      setPortal(true);
    }
  }, [stateroles, location.pathname]);

  return (
    <>
      {(isMd || isXl) && portal ? (
        <Box style={{ display: "flex", flexDirection: "column", minHeight: "100vh", position: "relative" }}>
          <CustomToolbar
            style={{ position: "absolute", top: 0, left: 0, width: "100%", zIndex: 0 }}
          />

          <Box
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "stretch",
              marginTop: isMd ? "5rem" : "8rem",
              marginBottom: "0.5rem",
            }}
          >
            <Card
              style={{
                background: "rgb(230, 227, 227)",
                display: "flex",
                width: "80%",

                padding: isMd ? "0.5rem" : "1rem",
                boxShadow: "10px 12px 20px 8px rgba(0, 0, 0.1, 0.3)",
                borderRadius: "20px",
                position: "relative",
                zIndex: 1,
              }}
            >
              <Box
                style={{
                  background: "rgb(230, 227, 227)",
                  display: stateroles.userId ? displayMenu : "none",
                  flexDirection: "column",
                }}
              >
                {isHospitalUser && isChemoPage ? <HospitalNavCard /> : <NavigationCard />}
              </Box>
              <Box
                style={{
                  flex: 1,
                  paddingRight: isMd ? "0" : "1rem",
                  maxWidth: "100%",
                  overflow: "auto",
                }}
              >
                {children}
              </Box>
            </Card>
          </Box>

          <Footer />
        </Box>
      ) : null}
      {isXs && portal ? (
        <Box sx={{ flexGrow: 1, display: "block" }}>
          <NavBarMobil />
          <Container>{children}</Container>
        </Box>
      ) : null}

      {!portal ? (
        <>
          <Container>{children}</Container>
        </>
      ) : null}
    </>
  );
};

export default MainCustomCard;
